import ParticipationVoteController from '@jury/api/ParticipationVoteController'
import SalonNominationController from '@jury/api/SalonNominationController'
import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState: Jury.Slices.Nominations.State = {
  nominations: [],
  tempVotes: {},
  status: 'idle',
  error: null
}

export const fetchNominations = createAsyncThunk(
    'nominations/index', 
    (payload: Jury.Slices.Nominations.FetchNominationsPayload) => SalonNominationController.index(payload.id)
)

export const voteNomination = createAsyncThunk(
  'nominations/votes/store',
  (payload: Jury.Slices.Nominations.VoteNominationPayload) => ParticipationVoteController.store(payload.id, payload.score)
)

export const nominationsSlice = createSlice({
  name: 'nominations',
  initialState,
  reducers: {
      assignTempVotesToNominations: (state) => {
        for (const [id, score] of Object.entries(state.tempVotes)) {
          const nomination = state.nominations.find(nomination => nomination.id === parseInt(id))

          if (!nomination)
            return

          nomination.vote = { score }
        }

        state.tempVotes = {}
      }
  },
  extraReducers(builder) {
    builder
        .addCase(fetchNominations.pending, (state) => {
            state.status = 'loading'
        })
        .addCase(fetchNominations.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.nominations = action.payload
        })
        .addCase(fetchNominations.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message
        })


    builder
      .addCase(voteNomination.pending, (state, action) => {
        const id = typeof action.meta.arg.id === 'number'
          ? action.meta.arg.id
          : parseInt(action.meta.arg.id)

        state.tempVotes[id] = action.meta.arg.score
      })
    }
})

export const { assignTempVotesToNominations } = nominationsSlice.actions

export default nominationsSlice.reducer